import { Pipe, PipeTransform } from "@angular/core";

// Takes AM/PM and returns a.m./p.m.
@Pipe({ name: 'formattedTime', standalone: false })
export class FormatTimePipe implements PipeTransform {
    transform(timeString: string): string {
        if (!timeString) { return '' }
        else if (timeString.match(/AM/gi)) {
            return timeString.replace(/AM/gi, 'a.m.')
        }
        else if (timeString.match(/PM/gi)) {
            return timeString.replace(/PM/gi, 'p.m.')
        }
        else { return timeString }
    }
}